/**
 * Created by mauget on 2/19/16.
 */

// NotificationsAttentionView.js


import 'jquery-ui/themes/base/base.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/progressbar.css';
import 'jquery-ui/themes/base/tooltip.css';
import $ from 'jquery';
import ui from 'jquery-ui';
import progressbar from 'jquery-ui/ui/widgets/progressbar.js';
import tooltip from 'jquery-ui/ui/widgets/tooltip.js';
import _ from 'lodash';
import moment from 'moment';
import Immutable from 'immutable';

import { View,Model } from 'backbone';
import PlayFormModal        from 'common-views/PlayFormModal.js';

import DashboardModel   from 'DashboardModel.js';
import constants        from 'Constants.js';
import util from 'util/Util.js';
import contentTemplate  from 'dashboard/notifications/attention-view.ejs';
import eventBus from "../../../service/EventBus";
import RestService from "RestService.js";
import NotificationService from "NotificationService.js";
import listService from '../../../service/ListService';

class NotificationsAttentionView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.template = contentTemplate;
        this.formSet = Immutable.Set();

        this.events={
            'change select,input[name=title]' : 'trackFilter',
            "click button#nDetails":'showNotificationDetails',
            "click button#nView":"viewForm",
            "click button#nHide":"hideNotification",
            "click button#nUnHide":"unHideNotification",
            "change input[name=showHidden]":"showOrHideNotifications", 
            'click #goToNotifications': 'goToNotifications'
        };

        // PF-5273 
        let showHiddenName = this.options.model.get('attentionLevel') == '0' ? '_showHiddenNotifications_NA' : '_showHiddenNotifications_A';
        let showHidden = listService.userSettings.get(showHiddenName);

        this.model.set({
            colModel: [
                {
                    name: 'icon',
                    index: 'icon',
                    width: 25,
                    editable: false
                },
                {
                    name: 'notificationId',
                    index: 'notificationId',
                    hidden:true
                },
                {
                    name: 'formId',
                    index: 'formId',
                    hidden:true
                },
                {
                    name: 'isHidden',
                    index: 'isHidden',
                    hidden:true
                },
                {
                    name: 'title',
                    index: 'title'
                },
                {
                    name: 'date',
                    index: 'date'
                },
                {
                    name: 'time',
                    index: 'time'
                },
                {
                    name: 'form',
                    index: 'form'
                },
                {
                    name: 'formInstance',
                    index: 'formInstance'
                },
                {
                    name: 'attentionLevel',
                    index: 'attentionLevel',
                    sorttype: this.sortAttention
                },
                {
                    name: 'isDraft',
                    index: 'isDraft',
                    hidden:true
                }
            ],
            colNames: [
                '&nbsp;',
                'NotificationId',
                'AppId',
                'IsHidden',
                'Title',
                'Date',
                'Time',
                'App',
                'App Instance',
                'Attention Level',
                ''
            ],
            showHidden
        }, {silent: true});
        this.onResize();
        this.initializeFilters(true);
       
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    sortAttention(cell, rowObject){
      
        switch(rowObject.attentionLevel){
            case 'Normal':return 1;
            case 'High':return 2;
            case 'Urgent':return 3;
            case 'Very Urgent':return 4;
            case 'Extremely Urgent':return 5;
            default: return 0;
        }
    }

    showHide(){
        $("#nHide").show();
        $("#nUnHide").hide();
    }

    showUnhide(){
        $("#nUnHide").show();
        $("#nHide").hide();
    }

    initializeFilters(init){
        let gridData = this.model.get('filteredGridData');
        if (gridData) {
            gridData.forEach((notification) => {
                this.formSet = this.formSet.add(notification['@FormName']);
            });
        }
        this.performFilter(init);
    }

    loadChart() {
        let notificationList = this.model.get('filteredGridDataWithHiddenValues');
        let notificationListLength = notificationList.length;
        let normalAttentionCount = notificationList.reduce((accum, elem) => {
            return elem["@AttentionLevel"] === "1" ? accum + 1 : accum;
        }, 0);
        let highAttentionCount = notificationList.reduce((accum, elem) => {
            return elem["@AttentionLevel"] === "2" ? accum + 1 : accum;
        }, 0);
        let urgentAttentionCount = notificationList.reduce((accum, elem) => {
            return elem["@AttentionLevel"] === "3" ? accum + 1 : accum;
        }, 0);
        let veryUrgentAttentionCount = notificationList.reduce((accum, elem) => {
            return elem["@AttentionLevel"] === "4" ? accum + 1 : accum;
        }, 0);
        let extremelyUrgentAttentionCount = notificationList.reduce((accum, elem) => {
            return elem["@AttentionLevel"] === "5" ? accum + 1 : accum;
        }, 0);

        const normalAttentionPercentage =_.round(((normalAttentionCount * 100) / notificationListLength),1);
        const highAttentionPercentage =_.round(((highAttentionCount * 100) / notificationListLength),1);
        const urgentAttentionPercentage =_.round(((urgentAttentionCount * 100) / notificationListLength),1);
        const veryUrgentAttentionPercentage =_.round(((veryUrgentAttentionCount * 100) / notificationListLength),1);
        const extremelyUrgentAttentionPercentage =_.round(((extremelyUrgentAttentionCount * 100) / notificationListLength),1);

        $('#progressbarNormal').progressbar({
            value: normalAttentionPercentage,
            create: function(event, ui) {
                $(this).css({'width': '10em','height': '1em',"margin-bottom": "5px"});
                $(this).find('.ui-progressbar-value').css({'background-color':'#47b87f','margin':0});
                $(this).find('.ui-widget.ui-widget-content').css({'margin':0});
            }
        });
        $('#progressbarHigh').progressbar({
            value:highAttentionPercentage,
            create: function(event, ui) {
                $(this).css({'width': '10em','height': '1em',"margin-bottom": "5px"});
                $(this).find('.ui-progressbar-value').css({'background-color':'#e4e4b4','margin':0});
                $(this).find('.ui-widget.ui-widget-content').css({'margin':0});
            }
        });
        $('#progressbarUrgent').progressbar({
            value:urgentAttentionPercentage,
            create: function(event, ui) {
                $(this).css({'width': '10em','height': '1em',"margin-bottom": "5px"});
                $(this).find('.ui-progressbar-value').css({'background-color':'#d5d585','margin':0});
                $(this).find('.ui-widget.ui-widget-content').css({'margin':0})
            }
        });
        $('#progressbarVeryUrgent').progressbar({
            value:veryUrgentAttentionPercentage,
            create: function(event, ui) {
                $(this).css({'width': '10em','height': '1em',"margin-bottom": "5px"});
                $(this).find('.ui-progressbar-value').css({'background-color':'#ff6666','margin':0});
                $(this).find('.ui-widget.ui-widget-content').css({'margin':0})
            }
        });
        $('#progressbarExtremelyUrgent').progressbar({
            value:extremelyUrgentAttentionPercentage,
            create: function(event, ui) {
                $(this).css({'width': '10em','height': '1em',"margin-bottom": "5px"});
                $(this).find('.ui-progressbar-value').css({'background-color':'#cc3333','margin':0});
                $(this).find('.ui-widget.ui-widget-content').css({'margin':0})
            }
        });

        $(this.$el).tooltip({
            items:"[data-extremely-chart],[data-very-urgent-chart],[data-urgent-chart],[data-high-chart],[data-normal-chart]",
            position: { my: "left+15 center", at: "right center" },
            content:function(){
                let element = $( this );
                if ( element.is( "[data-extremely-chart]" ) ) {
                    return "<div><b>Extremely Urgent Attention Needed</b>&#10;&#10;"+extremelyUrgentAttentionCount+" ("+extremelyUrgentAttentionPercentage+"%)&#10;total:"+notificationListLength+"</div>"
                }
                else if ( element.is( "[data-very-urgent-chart]" ) ) {
                    return "<div><b>Very Urgent Attention Needed</b>&#10;&#10;"+veryUrgentAttentionCount+" ("+veryUrgentAttentionPercentage+"%)&#10;total:"+notificationListLength+"</div>"
                }
                else if ( element.is( "[data-urgent-chart]" ) ) {
                    return "<div><b>Urgent Attention Needed</b>&#10;&#10;"+urgentAttentionCount+" ("+urgentAttentionPercentage+"%)&#10;total:"+notificationListLength+"</div>"
                }
                else if ( element.is( "[data-high-chart]" ) ) {
                    return "<div><b>High Attention Needed</b>&#10;&#10;"+highAttentionCount+" ("+highAttentionPercentage+"%)&#10;total:"+notificationListLength+"</div>"
                }
                    return "<div><b>Normal Attention Needed</b>&#10;&#10;"+normalAttentionCount+" ("+normalAttentionPercentage+"%)&#10;total:"+notificationListLength+"</div>"

            }
        });
    }

    trackFilter(ev){
        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        this.performFilter();
    }

    showOrHideNotifications(ev){
        if (ev.currentTarget.name == "showHidden") {
            let showHiddenName = this.model.get('attentionLevel') == '0' ? '_showHiddenNotifications_NA' : '_showHiddenNotifications_A';
            listService.userSettings.set(showHiddenName, ev.currentTarget.checked);
        }
        this.model.set(ev.currentTarget.name,ev.currentTarget.checked,{silent:true});
        this.performFilter();
    }

    getSelectedNotificationId(){
        let myGrid = $(this.gridEl),
            selRowId = myGrid.jqGrid ('getGridParam', 'selrow');
            return myGrid.jqGrid ('getCell', selRowId, 'notificationId');
    }


    // PF-5273
    getSelectedNotifications(){
        const selected = $(this.gridEl).getGridParam('selarrrow');         
        let selectedIds = [];
        let myGrid = $(this.gridEl);

        selected.forEach(notification => {
            selectedIds.push(myGrid.jqGrid ('getCell', notification, 'notificationId'));
        });
 
        return selectedIds;
    }

    // PF-5273
    getButtonAction(){
        let buttonAction = '';

        const selected = $(this.gridEl).getGridParam('selarrrow');         
        let currentStatus = '';
        for (let i = 0; i < selected.length; i++) {
            let rowData = $(this.gridEl).getRowData(selected[i]);
            if (currentStatus == '') {
                currentStatus = rowData['isHidden'];
                buttonAction = rowData['isHidden'] == 'True' ? 'unhide' : 'hide';
            } else {
                if (currentStatus != rowData['isHidden']) {
                    buttonAction = 'hide';
                    break;
                }
            }
        }

        return buttonAction;
    }

    getIfSelectedNotificationIsDraft(){
        let myGrid = $(this.gridEl),
            selRowId = myGrid.jqGrid ('getGridParam', 'selrow');
            return myGrid.jqGrid ('getCell', selRowId, 'isDraft').toLowerCase() === 'true';
    }

    getSelectedFormId(){
        let myGrid = $(this.gridEl),
            selRowId = myGrid.jqGrid ('getGridParam', 'selrow');
            return myGrid.jqGrid ('getCell', selRowId, 'formId');
    }

    showNotificationDetails(ev){
        const attention = this.model.get("isAttentionNeeded") ? "attentionNeeded" : "noAttentionNeeded";
        eventBus.trigger(constants.EV_SHOW_NOTIFICATION_DETAILS,this.getSelectedNotificationId(), attention);
    }

    hideNotification(ev){
        let searchValues={
            showHidden:this.model.get('showHidden'),
            form:this.model.get('form'),
            title:this.model.get('title'),
            attentionLevel:this.model.get('attentionLevel')
        };
        let selectedNotificationIds = this.getSelectedNotifications();
        let requestForHideNotifications='<Notifications>';
        // let requestForHideNotifications=`<Notifications><Notification id="${selectedNotificationId}"/></Notifications>`;

        // PF-5273 build new request with list of notifications
        selectedNotificationIds.forEach(notificationId => {
            requestForHideNotifications += `<Notification id="${notificationId}"/>`;
        });

        requestForHideNotifications += '</Notifications>';

        requestForHideNotifications = requestForHideNotifications.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        RestService.hideNotification(requestForHideNotifications).then((response)=>{
            eventBus.trigger(constants.EV_SHOW_ATTENTION_NOTIFICATION_DASHBOARD,undefined,this.model.get('isAttentionNeeded'),searchValues);
        }).catch((err=>{
            console.log('Error Hiding notification:',err);
            NotificationService.error('Error Hiding Notification '+err.MESSAGE);
        }));
    }

    unHideNotification(ev){
        let searchValues={
            showHidden:this.model.get('showHidden'),
            form:this.model.get('form'),
            title:this.model.get('title'),
            attentionLevel:this.model.get('attentionLevel')
        };
        let selectedNotificationIds = this.getSelectedNotifications();
        let requestForUnhideNotifications='<Notifications>';
        
        // PF-5273 build new request with list of notifications
        selectedNotificationIds.forEach(notificationId => {
            requestForUnhideNotifications += `<Notification id="${notificationId}"/>`;
        });

        requestForUnhideNotifications += '</Notifications>';
        requestForUnhideNotifications = requestForUnhideNotifications.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        RestService.unhideNotification(requestForUnhideNotifications).then((response)=>{
            eventBus.trigger(constants.EV_SHOW_ATTENTION_NOTIFICATION_DASHBOARD,undefined,this.model.get('isAttentionNeeded'),searchValues);
        }).catch((err=>{
            console.log('Error Hiding notification:',err);
            NotificationService.error('Error Hiding Notification '+err.MESSAGE);
        }));
    }


    viewForm(ev){
        this.playForm(this.getSelectedNotificationId());
    }

    playForm(id) {
        let instanceUrl = RestService.getLinkUrl(id);
        if (this.getIfSelectedNotificationIsDraft()){
            instanceUrl +=  '&isDraft=1';
        }
        instanceUrl +=  '&viewForm=true';
        const attributes = {url: instanceUrl, id: id };
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });
        newPlayForm.render().then((result) => {});
    }

    performFilter(init){
        let filterAttentionLevel=this.model.get('attentionLevel');
        let filterFormName=this.model.get('form');
        let filterHidden=this.model.get('showHidden');
        let currentGridData=this.model.get('gridData');
        let filterTitle=this.model.get('title');
        this.model.set('filteredGridData',Object.assign([],currentGridData),{silent:true});
        if(filterFormName !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@FormName",filterFormName);
        }

        if(filterAttentionLevel !== 'any'){
            currentGridData=this.filterByCriteria(currentGridData,"@AttentionLevel",filterAttentionLevel);
        }

        if(filterTitle !== ''){
            currentGridData=this.filterByCriteria(currentGridData,"@Title",filterTitle);
        }

        let filteredGridDataWithHiddenValues=Object.assign([],currentGridData);
        currentGridData=this.filterByCriteria(currentGridData,"@IsHidden",filterHidden);


        this.model.set('filteredGridData',currentGridData,{silent:true});
        this.model.set('filteredGridDataWithHiddenValues',filteredGridDataWithHiddenValues,{silent:true});
        this.render(init);
    }

    filterByCriteria(data,criteria,value){
        return data.filter((row)=>{
            if(criteria === '@AttentionLevel'){
                return this.filterByAttentionLevel(row[criteria],value)
            }
            if(criteria === '@Title'){
                return row[criteria].toLowerCase().startsWith(value.toLowerCase());
            }
            if(criteria === '@IsHidden' && !value){
                return row[criteria] === 'False';
            }
            if(criteria === '@IsHidden' && value){
                return row;
            }
                return row[criteria] === value;
        })
    }

    filterByAttentionLevel(attentionLevel,filter){
        switch (filter){
            case constants.NONE_ATTENTION_LEVEL:
            case constants.NORMAL_ATTENTION_LEVEL:
            case constants.HIGH_ATTENTION_LEVEL:
            case constants.URGENT_ATTENTION_LEVEL:
            case constants.VERY_URGENT_ATTENTION_LEVEL:
            case constants.EXTREMELY_URGENT_ATTENTION_LEVEL:
                return filter === attentionLevel;
            case constants.NORMAL_PLUS_ATTENTION_LEVEL:
                return (       attentionLevel === constants.NORMAL_ATTENTION_LEVEL ||
                                attentionLevel === constants.HIGH_ATTENTION_LEVEL ||
                                attentionLevel === constants.URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.VERY_URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.EXTREMELY_URGENT_ATTENTION_LEVEL);
            case constants.HIGH_PLUS_ATTENTION_LEVEL:
                return (       attentionLevel === constants.HIGH_ATTENTION_LEVEL ||
                                attentionLevel === constants.URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.VERY_URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.EXTREMELY_URGENT_ATTENTION_LEVEL);
            case constants.URGENT_PLUS_ATTENTION_LEVEL:
                return (       attentionLevel === constants.URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.VERY_URGENT_ATTENTION_LEVEL  ||
                                attentionLevel === constants.EXTREMELY_URGENT_ATTENTION_LEVEL);
            case constants.VERY_URGENT_PLUS_ATTENTION_LEVEL:
                return (       attentionLevel === constants.VERY_URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.EXTREMELY_URGENT_ATTENTION_LEVEL);
            default:
                return (       attentionLevel === constants.NONE_ATTENTION_LEVEL ||
                                attentionLevel === constants.NORMAL_ATTENTION_LEVEL ||
                                attentionLevel === constants.HIGH_ATTENTION_LEVEL ||
                                attentionLevel === constants.URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.VERY_URGENT_ATTENTION_LEVEL ||
                                attentionLevel === constants.EXTREMELY_URGENT_ATTENTION_LEVEL);
        }
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    fillNewRow(index, notificationId,formId,isHidden,title,date,time,form,formInstance,attentionLevel, failureReason, envelopeColor, isDraft) {
        $(this.gridEl).addRowData(index, {
            'icon': '<span class="icon fa fa-envelope" style="color: '+ envelopeColor +'"></span>',
            'notificationId':notificationId,
            'formId':formId,
            'isHidden':isHidden,
            'title':title,
            'date':date,
            'time':time,
            'form':form,
            'formInstance':formInstance,
            'attentionLevel':attentionLevel,
            'isDraft':isDraft
        });
    }

    createNewRow(index, notificationId,formId,isHidden,title,date,time,form,formInstance,attentionLevel, failureReason, envelopeColor, isDraft) {
        
        return {
            'icon': '<span class="icon fa fa-envelope" style="color: '+ envelopeColor +'"></span>',
            'notificationId':notificationId,
            'formId':formId,
            'isHidden':isHidden,
            'title':title,
            'date':date,
            'time':time,
            'form':form,
            'formInstance':formInstance,
            'attentionLevel':attentionLevel,
            'isDraft':isDraft
        };
    }

    onSelectRow(){
        this.enableActionButtons();
        this.enableHideOrUnhide();

    }

    

    enableActionButtons(){
        const selected = $(this.gridEl).getGridParam('selarrrow');
        if(!selected || selected.length === 0){
            $("button[id=nDetails]").prop('disabled',true);
            $("button[id=nView]").prop('disabled',true);
            $("button[id=nHide]").prop('disabled',true);
            $("button[id=nUnHide]").prop('disabled',true);
        }
        else{
            if (selected.length === 1) {
                $("button[id=nDetails]").prop('disabled',false);
                $("button[id=nView]").prop('disabled',false);
                $("button[id=nHide]").prop('disabled',false);
                $("button[id=nUnHide]").prop('disabled',false);
            } else {
                // Multiselect
                $("button[id=nDetails]").prop('disabled',true);
                $("button[id=nView]").prop('disabled',true);
                $("button[id=nHide]").prop('disabled',false);
                $("button[id=nUnHide]").prop('disabled',false);
            }
            
        }
    }

    enableHideOrUnhide(){
        const selected = $(this.gridEl).getGridParam('selarrrow');

        if (!selected)
            return;

        if (selected.length === 0) {
            this.showHide();
        } else if (selected.length === 1) {
            let selectedRow=$(this.gridEl).jqGrid("getGridParam","selrow"),
            rowData=$(this.gridEl).getRowData(selectedRow);
            if(rowData['isHidden'] ==='True'){
                this.showUnhide();
            }
            else{
                this.showHide();
            }
        } else {
            // Is multiple selection, check status
            let buttonAction = this.getButtonAction();
            if (buttonAction == 'hide') {
                this.showHide();
            } else {
                this.showUnhide();
            }
        }
        
    }

    onCellSelect(){}

    onDoubleClickRow(rowId,iRow,iCol,e) {
        const cell = $(this.gridEl).jqGrid ('getCell', rowId, 'notificationId');
        const attention = this.model.get("isAttentionNeeded") ? "attentionNeeded" : "noAttentionNeeded";
        eventBus.trigger(constants.EV_SHOW_NOTIFICATION_DETAILS, cell, attention);
    }

    setRow(rowId, e){
        console.log('before select row', e);
    }

    renderGrid(){
        let self = this;
        let itemsToRender=this.model.get('filteredGridData');

        //PF-6235 First process rows to send all of them to the jqgrid, calling addRowData for each element was causing performance issues
        const dataRows = [];
        _.forEach(itemsToRender, (field, index) => {
            // PF-5787 Server date is GMT, so we need to convert that date to local timezone
            let dateGMT = new Date(field['@Date'] + " GMT");
            dataRows.push(self.createNewRow(index,
                field['@NotificationId'],
                field['@FormId'],
                field['@IsHidden'],
                field['@Title'],
                dateGMT.toString('dd MMM yyyy'),
                dateGMT.toString("HH:mm"), 
                field['@FormName'],
                field['@InstanceName'],
                util.getNotificationAttentionLevel(field['@AttentionLevel']),
                field['@FailureReason'], 
                util.getAttentionLevelColor(field['@AttentionLevel']), 
                field['@IsDraft']));
        });

        let gridObject = util.getGridObject(this,{
            onDoubleClickRow:this.onDoubleClickRow,
            autowidth:true,
            height:400,
            scrollOffset:0,
            data: dataRows,
            cellEdit:false,
            multiselect: true,
            multiselectPosition: 'none',
            rowattr:function(item){
                if(item['isHidden'] === 'True' && self.model.get('showHidden')){
                    return { "class": "row-hidden" };
                }
            },
            gridComplete: () => {
                $(this.gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
                $(this.gridEl + " [aria-describedby*='isDraft']").each( (index, value) => {
                    if(util.isTrue(value.innerText)){
                        value.parentElement.style.fontStyle = "italic";
                    }                   
                });
            },
            beforeSelectRow : (rowid, e) => {
                // clear text selection
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }
        
                const $this = $(this.gridEl),
                startId = $this.getGridParam('selrow');
        
                if (!e.ctrlKey && !e.shiftKey) {
                    $this.resetSelection();
                } else if (e.shiftKey) {                 
                    $this.resetSelection();
                    const startRow = $this.getInd(startId);
                    const endRow = $this.getInd(rowid);
        
                    if (startRow && endRow) {
                        let startID = Math.min(startRow, endRow);
                        let endID = Math.max(startRow, endRow);
        
                        $.each($this.getDataIDs(), (i, id) => {
                            let index = $this.getInd(id);
                            if (index >= startID && index < endID) {
                                $this.setSelection(id, false);
                            }
                        });
                    }                    
                }
                return true;
            }
        });
        $(this.gridEl).jqGrid(gridObject);
    }

    fillFilter(selector,setToFilter,filterToSelect){
        let formSelect=$(selector);
        setToFilter.map((val)=>{
            formSelect.append($("<option></option>")
                .attr('value', val)
                .text(val));
        });
        formSelect.find(`option[value="${filterToSelect}"]`).prop('selected',true);
    }

    render(init) {
        let self=this;
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(!init){
            this.renderGrid();
        }
        this.fillFilter('select[name=form]',this.formSet,this.model.get('form'));
      
        // Attention Level selection
        $(`select[name=attentionLevel] option[value='${this.model.get('attentionLevel')}']`).prop('selected',true);
        $(`select[name=form] option[value='${this.model.get('form')}']`).prop('selected',true);
        $(`input[name="showHidden"]`).prop('selected',this.model.get('showHidden'));
        this.enableActionButtons();
        this.loadChart();
        this.showHide();

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

    goToNotifications(e) {
         e.preventDefault();
         e.stopPropagation(); 

         eventBus.trigger('loadNotificationsView');
    }
}

export default NotificationsAttentionView;

